module.exports = __webpack_public_path__ + "media/components/src/assets/images/line_4-e4fea320457ac421bbd06d2ba445cd0f.jpg";